/* ==========================================================================
   ATTITUDE — Product page behavior (Shopify cart AJAX)
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initGallery();
  initSizes();
  initStepper();
  initAccordion();
  initAddToCart();
});

function initGallery() {
  const mainImg = document.querySelector('.pdp__gallery-main img');
  const thumbs = document.querySelectorAll('.pdp__thumbs button');
  if (!mainImg || !thumbs.length) return;

  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => {
      thumbs.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const src = btn.dataset.full;
      mainImg.style.opacity = 0;
      window.setTimeout(() => {
        mainImg.src = src;
        mainImg.style.opacity = 1;
      }, 180);
    });
  });
}

/* ---- Taglia unica oggi, ma la struttura resta pronta se in futuro
   arrivano più taglie ---- */
function initSizes() {
  const sizes = document.querySelectorAll('.size-btn:not(:disabled)');
  sizes.forEach((s) => {
    s.addEventListener('click', () => {
      sizes.forEach((x) => x.classList.remove('is-active'));
      s.classList.add('is-active');
    });
  });
}

function initStepper() {
  const stepper = document.querySelector('.qty-stepper');
  const hiddenInput = document.querySelector('[data-qty-input]');
  if (!stepper) return;
  const display = stepper.querySelector('span');
  const minus = stepper.querySelector('[data-qty-minus]');
  const plus = stepper.querySelector('[data-qty-plus]');
  let qty = 1;
  const sync = () => {
    display.textContent = qty;
    if (hiddenInput) hiddenInput.value = qty;
  };
  minus.addEventListener('click', () => { qty = Math.max(1, qty - 1); sync(); });
  plus.addEventListener('click', () => { qty = Math.min(9, qty + 1); sync(); });
}

function initAccordion() {
  document.querySelectorAll('.accordion-item').forEach((item) => {
    const btn = item.querySelector('button');
    const panel = item.querySelector('.accordion-item__panel');
    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.accordion-item').forEach((i) => {
        i.classList.remove('is-open');
        i.querySelector('.accordion-item__panel').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

/* ---- Add to cart reale: POST /cart/add.js, poi rilegge /cart.js e
   aggiorna il drawer condiviso (definito in attitude-main.js) senza
   ricaricare la pagina ---- */
function initAddToCart() {
  const btn = document.querySelector('[data-add-to-cart]');
  const variantInput = document.querySelector('[data-variant-id]');
  const qtyInput = document.querySelector('[data-qty-input]');
  const feedback = document.querySelector('[data-add-feedback]');
  if (!btn || !variantInput) return;

  btn.addEventListener('click', () => {
    if (btn.disabled) return;
    if (feedback) feedback.textContent = '';

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantInput.value,
        quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
      })
    })
      .then((res) => {
        if (!res.ok) return res.json().then((data) => { throw new Error(data.description || 'add-to-cart-failed'); });
        return fetch('/cart.js');
      })
      .then((res) => res.json())
      .then((cart) => {
        btn.textContent = 'Aggiunto ✓';
        btn.classList.add('btn--hazard');
        if (window.AttitudeCart) {
          window.AttitudeCart.render(cart);
          window.AttitudeCart.open();
        }
      })
      .catch((err) => {
        if (feedback) feedback.textContent = 'Articolo non disponibile al momento.';
        console.error(err);
      })
      .finally(() => {
        window.setTimeout(() => {
          btn.disabled = false;
          btn.textContent = originalText;
          btn.classList.remove('btn--hazard');
        }, 1600);
      });
  });
}
